import React from 'react';
import { useIntl } from 'ha/i18n';
import { City } from '@ha/api/v2/types';

import { filterHiddenCities, citiesToFeaturedLinks } from '../../utils';

import {
  FeaturedLinksTitle,
  FeaturedLinksWrapper,
  FeaturedLinksContent,
  FeaturedLink,
  Spacer,
} from '../FeaturedLinks/FeaturedLinks';

interface Props {
  featuredCities?: City[];
}

export const FeaturedCities: React.FC<Props> = ({ featuredCities = [] }) => {
  const { T } = useIntl();

  if (featuredCities.length === 0) {
    return null;
  }

  const sortedCities: City[] = filterHiddenCities(featuredCities).sort(
    (city1, city2) => (city1.cityName > city2.cityName ? 1 : -1),
  );
  const featuredLinks: FeaturedLink[] = citiesToFeaturedLinks(sortedCities);

  return (
    <FeaturedLinksWrapper>
      <Spacer>
        <FeaturedLinksTitle titles={[T('Where will you go?')]} />
      </Spacer>
      <FeaturedLinksContent items={featuredLinks} maxItemsPerColumn={8} />
    </FeaturedLinksWrapper>
  );
};
